<template>
  <main class="stage">
    <b-container fluid>
      <b-row>
        <b-col>
          <b-row class="questions">
            <h2>What are your User Experience related questions?</h2>
            <ul>
              <li v-for="question in questionList" :key="question.index">
                {{ question.name ? question.name : "Someone" }} asks:
                <span>{{ question.message }}</span>
                <img :src="question.giphy" v-if="question.giphy" />
              </li>
            </ul>
            <div class="noQuestions" v-if="questionList.length === 0">
              No one has ask any questions yet, be the first!
            </div>
          </b-row>
        </b-col>
        <b-col cols="4">
          <b-row>
            <b-form @submit.prevent="sendQuestion">
              <h2>Submit Your Questions</h2>
              <b-form-group label="Your Name (Optional)" label-for="name">
                <b-form-input
                  id="name"
                  v-model="name"
                  placeholder="Enter name"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Your Question" label-for="message">
                <b-form-textarea
                  id="textarea"
                  v-model="message"
                  placeholder="Enter message..."
                  rows="3"
                  max-rows="6"
                  required
                ></b-form-textarea>
                <b-button
                  type="button"
                  variant="link"
                  block
                  v-if="!addGiphy"
                  @click="handleGiphy"
                >
                  Add Giphy
                </b-button>
              </b-form-group>
              <b-form-group label="Add Giphy" label-for="giphy" v-if="addGiphy">
                <b-form-input id="giphy" v-model="giphy"></b-form-input>
                <b-form-text id="input-live-help">
                  Right Click > Copy Image Address
                </b-form-text>
              </b-form-group>
              <b-button type="submit" variant="primary" block>
                Ask Question
              </b-button>
            </b-form>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import { getQuestions, submitQuestion } from "../firebase/ask";

export default {
  name: "Ask",
  data() {
    return {
      name: "",
      message: "",
      giphy: "",
      addGiphy: false,
      questionList: []
    };
  },
  firestore() {
    return {
      questionList: getQuestions()
    };
  },
  methods: {
    handleGiphy() {
      this.addGiphy = !this.addGiphy;
    },
    sendQuestion() {
      submitQuestion({
        name: this.name,
        message: this.message,
        giphy: this.giphy,
        createDate: new Date()
      }).then(() => {
        this.giphy = "";
        this.message = "";
      });
    }
  }
};
</script>

<style lang="postcss" scoped>
@import "../styles/ask/";
</style>
